const option = (label, value) => {
  return {
    label: label,
    value: value || label
  };
};
const Null = option('无', '无');
export const MEDICINE_OPTIONS = [option('是'), option('否')];
export const SYMPTOM_OPTIONS = [Null, option('经常头晕/头痛'), option('晕倒'), option('经常失眠'), option('经常感到焦虑/紧张/忧郁'), option('自残/自杀念头')];
export const CURE_WAYS_OPTIONS = [Null, option('传染性疾病治疗'), option('理疗'), option('心理治疗'), option('手术')];
export const CURE_DISEASE_OPTIONS = [
  Null,
  option('新型冠状病毒肺炎'),
  option('呼吸系统疾病：哮喘；慢性支气管炎；慢性肺炎；肺结核；气胸等'),
  option('循环系统（心血管系统)疾病：先天性心脏病；高血压；心肌炎；心律失常等'),
  option('消化系统疾病：胃/十二指肠溃疡；肝炎；消化道出血；胆囊炎；慢性胃炎、肠炎等'),
  option('血液系统疾病：贫血；血友病；白血病等'),
  option('内分泌系统疾病：糖尿病；甲状腺疾病（甲亢、甲减等）；痛风（高尿酸血症）等'),
  option('神经系统疾病：癫痫；癔症；脑出血；一过性晕厥等'),
  option('泌尿系统疾病：慢性肾病（肾炎）'),
  option('风湿免疫系统疾病：类风湿性关节炎；骨关节炎等'),
  option('心理疾病：焦虑症、抑郁症、躁狂症等'),
  option('其他严重过敏或过敏性疾病')
];
export default {
  MEDICINE_OPTIONS,
  SYMPTOM_OPTIONS,
  CURE_WAYS_OPTIONS,
  CURE_DISEASE_OPTIONS
};
